/* src/app/shared/components/switch-button/switch-button.component.scss */
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-Regular.ttf") format("truetype");
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-RegularItalic.ttf") format("truetype");
  font-style: italic;
  font-weight: 500;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-Bold.ttf") format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-BoldItalic.ttf") format("truetype");
  font-style: italic;
  font-weight: bold;
}
.container-box {
  background: #fff;
}
.filter-container {
  position: relative;
  padding: 0;
  min-height: 10.5rem;
}
.box-container {
  overflow: hidden;
  position: relative;
  margin-right: 0.5rem;
  padding: 0;
  min-height: 10.5rem;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #FFF;
}
.box-container .box-header {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 1rem;
  color: var(--secondary);
}
.box-container .box-header.h6 {
  font-size: 1rem;
  margin-top: 1.2rem;
}
.box-container .box-body {
  padding: 0.1rem 0.8rem;
}
.collapse-filters {
  position: absolute;
  z-index: 100;
  width: 100.5%;
  margin-left: -1.3rem;
  padding-left: 1.6rem;
  background: #fff;
  border-left: 5px solid rgb(109, 110, 106);
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
}
::ng-deep .ant-select {
  margin-top: 0;
}
::ng-deep .nz-checkbox-wrapper label {
  top: 0.2rem !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 23px;
  margin-right: 1rem;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #39322B;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: var(--primary);
}
input:focus + .slider {
  box-shadow: 0 0 1px var(--primary);
}
input:checked + .slider:before {
  -webkit-transform: translateX(23px);
  -ms-transform: translateX(23px);
  transform: translateX(23px);
}
.slider.round {
  border-radius: 34px;
  width: 45px;
  height: 23px;
}
.slider.round:before {
  border-radius: 50%;
}
.switchBtn {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 0.3rem;
}
.switchBtn span.beforeLabelSwitchBtn {
  display: inline-flex;
}
.switchBtn .switchBtnTxt {
  line-height: 2.2rem;
  font-size: 1.1rem;
  color: #808080;
}
.optionsList {
  padding-left: 1rem;
}
.custom-round-checkbox {
  display: inline-block;
  position: relative;
  padding-left: 1rem;
  cursor: pointer;
  font-weight: 500;
  font-size: 1.2em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkBoxText {
  padding-left: 1rem;
  line-height: normal;
  font-size: 1.1rem;
  color: #808080;
}
.custom-round-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 2px #000 solid;
  background-color: #fff;
  border-radius: 50%;
}
.container:hover input ~ .checkmark {
  background-color: #fff;
}
.custom-round-checkbox input:checked ~ .checkmark {
  border: 2px #69ab55 solid;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.custom-round-checkbox input:checked ~ .checkmark:after {
  display: block;
}
.custom-round-checkbox input:checked ~ span.label {
  color: #13A114;
}
.custom-round-checkbox .checkmark:after {
  top: 3px;
  left: 3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #13A114;
}
.custom-square-checkbox {
  display: inline-flex;
  position: relative;
  padding-left: 1rem;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.custom-square-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.custom-square-checkbox .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border-radius: 2px;
  border: 2px #808080 solid;
}
.custom-square-checkbox:hover input ~ .checkmark {
  background-color: var(--secondary);
}
.custom-square-checkbox input:checked ~ .checkmark {
  background-color: var(--primary);
  border-color: var(--primary);
}
.custom-square-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.custom-square-checkbox input:checked ~ .checkmark:after {
  display: block;
}
.custom-square-checkbox .checkmark:after {
  left: 5px;
  top: 0;
  width: 7px;
  height: 13px;
  border: solid #fff;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
@media only screen and (max-width: 480px) {
  .switch {
    margin-right: 2.5rem;
  }
  .switchBtn span {
    line-height: 1.3em;
  }
}
.disabled {
  pointer-events: none;
  background-color: gray;
}
/*# sourceMappingURL=switch-button.component.css.map */
